import { useEffect } from "react";

import { useAccessibilitySettings } from "@/hooks/useAccessibilitySettings";

export function GlobalAccessibilityEffects() {
  const { settings } = useAccessibilitySettings();

  useEffect(() => {
    const root = document.documentElement;

    // Apply global font scale CSS variable
    root.style.setProperty("--font-scale", String(settings.fontScale));
  }, [settings.fontScale]);

  /**
   * AUTO-CONVERT px FONT SIZES TO SCALABLE rem ACROSS ENTIRE APP
   * This runs once and fixes all px-based rules, even in external CSS files.
   */
  useEffect(() => {
    const convertPxToRem = () => {
      const BASE = 16; // Root base font size (16px)

      // Find all stylesheets
      for (const sheet of document.styleSheets) {
        let rules: CSSRuleList;
        try {
          rules = sheet.cssRules; // may throw for cross-origin
        } catch {
          continue;
        }
        if (!rules) continue;

        for (const rule of rules) {
          if (!(rule as CSSStyleRule).style) continue;
          const style = (rule as CSSStyleRule).style;

          const fontSize = style.fontSize;
          if (fontSize && fontSize.endsWith("px")) {
            const pxValue = parseFloat(fontSize);
            const remValue = pxValue / BASE;

            style.fontSize = `${remValue}rem`; // replace with scalable unit
          }
        }
      }
    };

    convertPxToRem();
  }, []); // runs once at startup

  return null;
}
